import "./namespace.js";
import "./content_frame.js";

document.addEventListener("DOMContentLoaded", () => {
  if (window.name == "call-center-iframe") {
    new ContentFrame();
  }
});
